<div class="barcode-input-surface">
  <mat-form-field class="barcode-input-field-outline" appearance="outline">
    <mat-label>{{ inputTitle }}</mat-label>
    <input matInput [(ngModel)]="searchValue" appAutofocus #barcode autocomplete="off" value="" placeholder="" />
    <button *ngIf="icon" mat-icon-button matSuffix (click)="iconPressed()">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
  </mat-form-field>
</div>
